import {
    Box,
    HStack,
    VStack,
    Text,
    Icon,
    Button,
} from "@chakra-ui/react";

import {
    CheckCircle,
    AlertTriangle,
    AlertCircle,
    Info,
} from "lucide-react";

const toastConfig = {
    success: {
        icon: CheckCircle,
        borderColor: "#2563EB",
        iconBg: "#DBEAFE",
        iconColor: "#2563EB",
    },
    error: {
        icon: AlertCircle,
        borderColor: "#DC2626",
        iconBg: "#FEE2E2",
        iconColor: "#DC2626",
    },
    warning: {
        icon: AlertTriangle,
        borderColor: "#F59E0B",
        iconBg: "#FEF3C7",
        iconColor: "#D97706",
    },
    info: {
        icon: Info,
        borderColor: "#2563EB",
        iconBg: "#DBEAFE",
        iconColor: "#2563EB",
    },
};

const ActivityToast = ({
    type = "success",
    title,
    description,
    timestamp = "Just now",
    actionLabel,
    onAction,
}) => {
    const config = toastConfig[type];
    const IconComponent = config.icon;

    return (
        <Box
            bg="white"
            borderRadius="12px"
            boxShadow="lg"
            overflow="hidden"
            maxW="420px"
            borderLeft="4px solid"
            borderLeftColor={config.borderColor}
        >
            <HStack
                align="start"
                p={4}
                spacing={4}
            >
                <Box
                    bg={config.iconBg}
                    w="40px"
                    h="40px"
                    borderRadius="full"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexShrink={0}
                >
                    <Icon
                        as={IconComponent}
                        color={config.iconColor}
                        boxSize={5}
                    />
                </Box>

                <VStack
                    align="start"
                    flex={1}
                    spacing={1}
                >
                    <HStack
                        justify="space-between"
                        w="full"
                    >
                        <Text
                            fontWeight="700"
                            fontSize="sm"
                        >
                            {title}
                        </Text>

                        <Text
                            fontSize="xs"
                            color="gray.500"
                        >
                            {timestamp}
                        </Text>
                    </HStack>

                    <Text
                        fontSize="sm"
                        color="gray.600"
                    >
                        {description}
                    </Text>

                    {actionLabel && (
                        <Button
                            size="xs"
                            colorScheme="red"
                            mt={2}
                            onClick={onAction}
                        >
                            {actionLabel}
                        </Button>
                    )}
                </VStack>
            </HStack>
        </Box>
    );
};

export default ActivityToast;